import { Transaction } from '@/types';
import { useMemo } from 'react';

export const useTransactionSelectors = (transactions: Transaction[]) => {
  return useMemo(() => ({
    getByCard: (cardId: string) =>
      transactions.filter(t => t.cardId === cardId),
    
    getByAccount: (accountId: string) =>
      transactions.filter(t => t.accountId === accountId),
    
    getRecent: (limit: number = 10) =>
      [...transactions]
        .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
        .slice(0, limit),
    
    getByDateRange: (startDate: string, endDate: string) =>
      transactions.filter(t => t.date >= startDate && t.date <= endDate),
    
    getByType: (type: 'receita' | 'despesa') =>
      transactions.filter(t => t.type === type),
    
    getByCategory: (categoryId: string) =>
      transactions.filter(t => t.categoryId === categoryId),
    
    getTotalByType: (type: 'receita' | 'despesa') =>
      transactions
        .filter(t => t.type === type)
        .reduce((sum, t) => sum + t.amount, 0),
  }), [transactions]);
};
